import { formatMoney } from "../lib/formatMoney";
import type { MenuItem } from "../lib/menuTypes";
import { ModifierList } from "./ModifierList";

type MenuItemCardProps = {
  item: MenuItem;
  displayMode?: boolean;
};

export function MenuItemCard({ item, displayMode = false }: MenuItemCardProps) {
  const showVariationGrid = item.variations.length > 1;

  return (
    <article className={`menu-card${displayMode ? " menu-card--display" : ""}`}>
      {item.imageUrl ? (
        <img className="menu-card__image" src={item.imageUrl} alt="" loading="lazy" decoding="async" />
      ) : null}
      <div className="menu-card__body">
        <div className="menu-card__topline">
          <div>
            <h3>{item.customerFacingName || item.name}</h3>
            {item.customerFacingName && item.customerFacingName !== item.name ? <p className="menu-card__square-name">{item.name}</p> : null}
          </div>
          {typeof item.basePrice === "number" && item.basePrice > 0 ? (
            <strong className="menu-card__price">{formatMoney(item.basePrice)}</strong>
          ) : null}
        </div>

        {item.description ? <p className="menu-card__description">{item.description}</p> : null}

        {showVariationGrid ? (
          <div className="variation-grid" aria-label={`${item.name} sizes and prices`}>
            {item.variations.map((variation) => (
              <div
                className={`variation-row${variation.isSoldOut ? " variation-row--sold-out" : ""}${
                  variation.isAlmostGone ? " variation-row--almost-gone" : ""
                }`}
                key={variation.id}
              >
                <span>
                  {variation.name}
                  {variation.isSoldOut ? <em>Sold out</em> : null}
                  {!variation.isSoldOut && variation.isAlmostGone ? <em>Almost gone!</em> : null}
                </span>
                {!item.hasUniformVariationPricing && variation.price > 0 ? <strong>{formatMoney(variation.price)}</strong> : null}
              </div>
            ))}
          </div>
        ) : null}

        {item.modifierLists.length > 0 ? (
          <div className="menu-card__modifiers">
            {item.modifierLists.map((list) => (
              <ModifierList list={list} key={list.id} />
            ))}
          </div>
        ) : null}
      </div>
    </article>
  );
}
